















































































import type { PageDataPropUnion } from "@constructor/shared-entity/type";
import { defineComponent, type PropType } from "vue-demi";
import getValueForProp from "../../../helper/getValueForProp";

export default defineComponent({
  name: "FCDarkstore",
  props: {
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
  },
  computed: {
    darkstoreUrl() {
      return getValueForProp("darkstoreUrl", this.prop) || undefined;
    },
  },
});
